<form>
   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showBackgroundImage">
         <input
            type="checkbox"
            id="showBackgroundImage"
            [checked]="showBackgroundImage$ | async"
            (click)="changeShowBackgroundImage($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.user-status-brick.settings.show-background-image' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showUsername">
         <input
            type="checkbox"
            id="showUsername"
            [checked]="showUsername$ | async"
            (click)="changeShowUsername($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.user-status-brick.settings.show-user-name' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showPrivateDn">
         <input
            type="checkbox"
            id="showPrivateDn"
            [checked]="showPrivateDn$ | async"
            (click)="changeShowPrivateDn($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.user-status-brick.settings.show-private-dn' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showAvatar">
         <input
            type="checkbox"
            id="showAvatar"
            [checked]="showAvatar$ | async"
            (click)="changeShowAvatar($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.user-status-brick.settings.show-avatar' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showAlternativeDeviceEditor">
         <input
            type="checkbox"
            id="showAlternativeDeviceEditor"
            [checked]="showAlternativeDeviceEditor$ | async"
            (click)="changeShowAlternativeDeviceEditor($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.user-status-brick.settings.show-alternative-device-editor' | translate }}
      </label>
   </div>

   <div class="sam-form-row">
      <label class="k-checkbox-label" for="showStatusDropdown">
         <input
            type="checkbox"
            id="showStatusDropdown"
            [checked]="showStatusDropdown$ | async"
            (click)="changeShowStatusDropdown($event.currentTarget.checked)"
            class="k-checkbox"
         />
         {{ 'brick.brick_definitions.user-status-brick.settings.show-status-dropdown' | translate }}
      </label>
   </div>
</form>
